import React, { useState } from "react";
import "./Admin_dashboard.css";
import "./AddStudent.css";
import { Underline, Floatinmenu } from "../../widgets";
import { admin_menu } from "../../constants/dashboard";
import axios from "axios";

const genderOptions = ["M", "F", "Other"];
const bloodGroups = [
    "O+", "A+", "B+", "AB+", "A-", "B-", "AB-", "O-",
    "A1+", "A1B+", "A1-", "A1B-", "A2+", "A2B+", "A2B-",
    "O1+", "O1-", "O2+", "O2-"
];
const hostellerOptions = ["Yes", "No"];
const programmeOptions = ["BE-Full Time", "BE-Part Time", "ME-Full Time", "ME-Part Time"];
const studentTypeOptions = ["Regular", "Lateral Entry"];
const batchOptions = [,"2024-28","2023-27", "2022-26", "2021-25", "2020-24"];

const initialState = {
    regno: "",
    studentname: "",
    dob: "",
    gender: "",
    batch: "",
    programme: "",
    mailid: "",
    phoneno: "",
    parent_no: "",
    hosteller: "",
    blood_grp: "",
    emis_no: "",
    student_type: "",
    regulation: "", 
    cgpa:0.0,
};

function formatDOB(input) {
    if (!input) return "";
    const [year, month, day] = input.split("-");
    if (!year || !month || !day) return input;
    const months = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const mIdx = parseInt(month, 10) - 1;
    if (mIdx < 0 || mIdx > 11) return input;
    return `${day} ${months[mIdx]} ${year}`;
}

export default function AddStudent() {
    const [student, setStudent] = useState(initialState);
    const [errors, setErrors] = useState({});

    const validate = () => {
        const errs = {};
        if (!/^\d{11}$/.test(student.regno)) errs.regno = "Reg No must be 11 digits";
        if (!student.studentname.trim()) errs.studentname = "Name required";
        if (!student.dob) errs.dob = "DOB required";
        if (!student.gender) errs.gender = "Select gender";
        if (!student.batch) errs.batch = "Select batch";
        if (!student.programme) errs.programme = "Select programme";
        if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(student.mailid))
            errs.mailid = "Invalid email";
        if (!/^\d{10}$/.test(student.phoneno)) errs.phoneno = "Phone must be 10 digits";
        if (!/^\d{10}$/.test(student.parent_no)) errs.parent_no = "Parent No must be 10 digits";
        if (!student.hosteller) errs.hosteller = "Select hosteller status";
        if (!student.blood_grp) errs.blood_grp = "Select blood group";
        if (!/^\d{10}$/.test(student.emis_no)) errs.emis_no = "EMIS No must be 10 digits";
        if (!student.student_type) errs.student_type = "Select student type";
        if(!student.regulation) errs.regulation = "Select regulation";
        return errs;
    };

    const handleChange = (e) => {
        setStudent({ ...student, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errs = validate();
        setErrors(errs);
        if (Object.keys(errs).length) return;
        try {
            console.log("Submitting student data:", student);
            const res = await axios.post("backend/addstudent", student);
            if (res.data.Status === "Success") {    
                alert("Student added successfully");
                setStudent(initialState);
                setErrors({});
            } else {
                alert(res.data.message || "Failed to add student");
            }
        } catch (err) {
            console.error(err);
            alert("Error adding student");
        }
    };

    return (
        <div className="add_student_container">
            <Underline heading="Add Student" />
            <div className="add_student_content">
                <Floatinmenu head="Menu" links={admin_menu} />
                <form className="add_student_form" onSubmit={handleSubmit} autoComplete="off">
                    <div className="floating-input">
                        <input
                            type="text"
                            name="studentname"
                            value={student.studentname.toUpperCase()}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="studentname">NAME</label>
                        {errors.studentname && <span className="error">{errors.studentname}</span>}
                    </div>
                    <div className="floating-input">
                        <input
                            type="text"
                            name="regno"
                            value={student.regno}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="regno">REG NO</label>
                        {errors.regno && <span className="error">{errors.regno}</span>}
                    </div>
                    <div className="floating-input">
                        <input
                            type="date"
                            name="dob"
                            value={student.dob}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="dob">DOB</label>
                        {errors.dob && <span className="error">{errors.dob}</span>}
                        {student.dob && (
                            <div className="dob-formatted">
                                {formatDOB(student.dob)}
                            </div>
                        )}
                    </div>
                    <div className="floating-input">
                        <select name="gender" value={student.gender} onChange={handleChange} required>
                            <option value=""></option>
                            {genderOptions.map((g) => (
                                <option key={g} value={g}>{g}</option>
                            ))}
                        </select>
                        <label htmlFor="gender">GENDER</label>
                        {errors.gender && <span className="error">{errors.gender}</span>}
                    </div>
                    <div className="floating-input">
                        <select name="batch" value={student.batch} onChange={handleChange} required>
                            <option value=""></option>
                            {batchOptions.map((b) => (
                                <option key={b} value={b}>{b}</option>
                            ))}
                        </select>
                        <label htmlFor="batch">BATCH</label>
                        {errors.batch && <span className="error">{errors.batch}</span>}
                    </div>
                    <div className="floating-input">
                        <select name="programme" value={student.programme} onChange={handleChange} required>
                            <option value=""></option>
                            {programmeOptions.map((p) => (
                                <option key={p} value={p}>{p}</option>
                            ))}
                        </select>
                        <label htmlFor="programme">PROGRAMME</label>
                        {errors.programme && <span className="error">{errors.programme}</span>}
                    </div>
                    {/* CGPA input removed */}
                    <div className="floating-input">
                        <input
                            type="email"
                            name="mailid"
                            value={student.mailid}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="mailid">MAIL ID</label>
                        {errors.mailid && <span className="error">{errors.mailid}</span>}
                    </div>
                    <div className="floating-input">
                        <input
                            type="text"
                            name="phoneno"
                            value={student.phoneno}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="phoneno">PHONE</label>
                        {errors.phoneno && <span className="error">{errors.phoneno}</span>}
                    </div>
                    <div className="floating-input">
                        <input
                            type="text"
                            name="parent_no"
                            value={student.parent_no}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="parent_no">PARENT NO</label>
                        {errors.parent_no && <span className="error">{errors.parent_no}</span>}
                    </div>
                    <div className="floating-input">
                        <select name="hosteller" value={student.hosteller} onChange={handleChange} required>
                            <option value=""></option>
                            {hostellerOptions.map((h) => (
                                <option key={h} value={h}>{h}</option>
                            ))}
                        </select>
                        <label htmlFor="hosteller">HOSTELLER</label>
                        {errors.hosteller && <span className="error">{errors.hosteller}</span>}
                    </div>
                    <div className="floating-input">
                        <select name="blood_grp" value={student.blood_grp} onChange={handleChange} required>
                            <option value=""></option>
                            {bloodGroups.map((bg) => (
                                <option key={bg} value={bg}>{bg}</option>
                            ))}
                        </select>
                        <label htmlFor="blood_grp">BLOOD GROUP</label>
                        {errors.blood_grp && <span className="error">{errors.blood_grp}</span>}
                    </div>
                    <div className="floating-input">
                        <input
                            type="text"
                            name="emis_no"
                            value={student.emis_no}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="emis_no">EMIS NO</label>
                        {errors.emis_no && <span className="error">{errors.emis_no}</span>}
                    </div>
                    <div className="floating-input">
                        <input
                            type="text"
                            name="regulation"
                            value={student.regulation}
                            onChange={handleChange}
                            required
                        />
                        <label htmlFor="regulation">REGULATION</label>
                        {errors.regulation && <span className="error">{errors.regulation}</span>}
                    </div>
                    <div className="floating-input">
                        <select name="student_type" value={student.student_type} onChange={handleChange} required>
                            <option value=""></option>
                            {studentTypeOptions.map((s) => (
                                <option key={s} value={s}>{s}</option>
                            ))}
                        </select>
                        <label htmlFor="student_type">STUDENT TYPE</label>
                        {errors.student_type && <span className="error">{errors.student_type}</span>}
                    </div>
                    <button className="submit_button" type="submit">
                        Add Student
                    </button>
                </form>
            </div>
            <div className="logout_button">
            <a className="log_link" href="/logout">
              Logout
            </a>
            </div>
        </div>
    );
}
